export const SET_APPLICATION_LOG_LOADING = 'SET_APPLICATION_LOG_LOADING';
export const CLEAR_APPLICATION_LOG_ERROR = 'CLEAR_APPLICATION_LOG_ERROR';
export const CLEAR_SELECTED_APPLICATION_LOG = 'CLEAR_SELECTED_APPLICATION_LOG';

// =========================
// Logs
// =========================
export const GET_APPLICATION_LOGS_REQUEST = 'GET_APPLICATION_LOGS_REQUEST';
export const GET_APPLICATION_LOGS_SUCCESS = 'GET_APPLICATION_LOGS_SUCCESS';
export const GET_APPLICATION_LOGS_FAIL = 'GET_APPLICATION_LOGS_FAIL';

export const GET_APPLICATION_LOG_REQUEST = 'GET_APPLICATION_LOG_REQUEST';
export const GET_APPLICATION_LOG_SUCCESS = 'GET_APPLICATION_LOG_SUCCESS';
export const GET_APPLICATION_LOG_FAIL = 'GET_APPLICATION_LOG_FAIL';

export const GET_APPLICATION_LOGS_BY_MODULE_REQUEST = 'GET_APPLICATION_LOGS_BY_MODULE_REQUEST';
export const GET_APPLICATION_LOGS_BY_MODULE_SUCCESS = 'GET_APPLICATION_LOGS_BY_MODULE_SUCCESS';
export const GET_APPLICATION_LOGS_BY_MODULE_FAIL = 'GET_APPLICATION_LOGS_BY_MODULE_FAIL';

export const GET_APPLICATION_LOGS_BY_USER_REQUEST = 'GET_APPLICATION_LOGS_BY_USER_REQUEST';
export const GET_APPLICATION_LOGS_BY_USER_SUCCESS = 'GET_APPLICATION_LOGS_BY_USER_SUCCESS';
export const GET_APPLICATION_LOGS_BY_USER_FAIL = 'GET_APPLICATION_LOGS_BY_USER_FAIL';

export const GET_MY_ACTIVITY_SUMMARY_REQUEST = 'GET_MY_ACTIVITY_SUMMARY_REQUEST';
export const GET_MY_ACTIVITY_SUMMARY_SUCCESS = 'GET_MY_ACTIVITY_SUMMARY_SUCCESS';
export const GET_MY_ACTIVITY_SUMMARY_FAIL = 'GET_MY_ACTIVITY_SUMMARY_FAIL';

// =========================
// Action creators
// =========================
export const setApplicationLogLoading = (loading) => ({
    type: SET_APPLICATION_LOG_LOADING,
    payload: loading
});

export const clearApplicationLogError = () => ({
    type: CLEAR_APPLICATION_LOG_ERROR
});

export const clearSelectedApplicationLog = () => ({
    type: CLEAR_SELECTED_APPLICATION_LOG
});

// ---------- GET ALL LOGS ----------
export const getApplicationLogsRequest = () => ({
    type: GET_APPLICATION_LOGS_REQUEST
});

export const getApplicationLogsSuccess = (logs) => ({
    type: GET_APPLICATION_LOGS_SUCCESS,
    payload: logs
});

export const getApplicationLogsFail = (error) => ({
    type: GET_APPLICATION_LOGS_FAIL,
    error
});

// ---------- GET LOG BY ID ----------
export const getApplicationLogRequest = (id) => ({
    type: GET_APPLICATION_LOG_REQUEST,
    payload: { id }
});

export const getApplicationLogSuccess = (log) => ({
    type: GET_APPLICATION_LOG_SUCCESS,
    payload: log
});

export const getApplicationLogFail = (error) => ({
    type: GET_APPLICATION_LOG_FAIL,
    error
});

// ---------- GET LOGS BY MODULE ----------
export const getApplicationLogsByModuleRequest = (module) => ({
    type: GET_APPLICATION_LOGS_BY_MODULE_REQUEST,
    payload: { module }
});

export const getApplicationLogsByModuleSuccess = (logs) => ({
    type: GET_APPLICATION_LOGS_BY_MODULE_SUCCESS,
    payload: logs
});

export const getApplicationLogsByModuleFail = (error) => ({
    type: GET_APPLICATION_LOGS_BY_MODULE_FAIL,
    error
});

// ---------- GET LOGS BY USER ----------
export const getApplicationLogsByUserRequest = (targetUserId) => ({
    type: GET_APPLICATION_LOGS_BY_USER_REQUEST,
    payload: { targetUserId }
});

export const getApplicationLogsByUserSuccess = (logs) => ({
    type: GET_APPLICATION_LOGS_BY_USER_SUCCESS,
    payload: logs
});

export const getApplicationLogsByUserFail = (error) => ({
    type: GET_APPLICATION_LOGS_BY_USER_FAIL,
    error
});

// ---------- GET MY ACTIVITY SUMMARY ----------
export const getMyActivitySummaryRequest = (months = 9) => ({
    type: GET_MY_ACTIVITY_SUMMARY_REQUEST,
    payload: { months }
});

export const getMyActivitySummarySuccess = (activitySummary) => ({
    type: GET_MY_ACTIVITY_SUMMARY_SUCCESS,
    payload: activitySummary
});

export const getMyActivitySummaryFail = (error) => ({
    type: GET_MY_ACTIVITY_SUMMARY_FAIL,
    error
});
